/* projects/shared/nvps-libraries/design/nv-icon-button/nv-icon-button.scss */
:root {
  --color-white: #ffffff;
  --color-white-90: white;
  --color-white-80: white;
  --color-white-70: white;
  --color-white-60: white;
  --color-white-50: white;
  --color-white-40: white;
  --color-white-30: white;
  --color-white-20: white;
  --color-white-10: white;
  --color-white-5: white;
  --color-white-3: white;
  --color-white-1: white;
  --color-white-dark: rgb(229.5, 229.5, 229.5);
  --color-white-dark-80: #cccccc;
  --color-white-dark-70: rgb(178.5, 178.5, 178.5);
  --color-white-dark-60: #999999;
  --color-white-dark-50: rgb(127.5, 127.5, 127.5);
  --color-black: #000000;
  --color-black-90: rgb(25.5, 25.5, 25.5);
  --color-black-80: #333333;
  --color-black-70: rgb(76.5, 76.5, 76.5);
  --color-black-60: #666666;
  --color-black-50: rgb(127.5, 127.5, 127.5);
  --color-black-40: #999999;
  --color-black-30: rgb(178.5, 178.5, 178.5);
  --color-black-20: #cccccc;
  --color-black-10: rgb(229.5, 229.5, 229.5);
  --color-black-5: rgb(242.25, 242.25, 242.25);
  --color-black-3: rgb(247.35, 247.35, 247.35);
  --color-black-1: rgb(252.45, 252.45, 252.45);
  --color-black-dark: black;
  --color-black-dark-80: black;
  --color-black-dark-70: black;
  --color-black-dark-60: black;
  --color-black-dark-50: black;
  --color-red: rgb(194, 0, 24);
  --color-red-90: rgb(200.1, 25.5, 47.1);
  --color-red-80: rgb(206.2, 51, 70.2);
  --color-red-70: rgb(212.3, 76.5, 93.3);
  --color-red-60: rgb(218.4, 102, 116.4);
  --color-red-50: rgb(224.5, 127.5, 139.5);
  --color-red-40: rgb(230.6, 153, 162.6);
  --color-red-30: rgb(236.7, 178.5, 185.7);
  --color-red-20: rgb(242.8, 204, 208.8);
  --color-red-10: rgb(248.9, 229.5, 231.9);
  --color-red-5: rgb(251.95, 242.25, 243.45);
  --color-red-3: rgb(253.17, 247.35, 248.07);
  --color-red-1: rgb(254.39, 252.45, 252.69);
  --color-red-dark: rgb(174.6, 0, 21.6);
  --color-red-dark-80: rgb(155.2, 0, 19.2);
  --color-red-dark-70: rgb(135.8, 0, 16.8);
  --color-red-dark-60: rgb(116.4, 0, 14.4);
  --color-red-dark-50: #61000c;
  --color-pink: rgb(255, 92, 143);
  --color-pink-90: rgb(255, 108.3, 154.2);
  --color-pink-80: rgb(255, 124.6, 165.4);
  --color-pink-70: rgb(255, 140.9, 176.6);
  --color-pink-60: rgb(255, 157.2, 187.8);
  --color-pink-50: rgb(255, 173.5, 199);
  --color-pink-40: rgb(255, 189.8, 210.2);
  --color-pink-30: rgb(255, 206.1, 221.4);
  --color-pink-20: rgb(255, 222.4, 232.6);
  --color-pink-10: rgb(255, 238.7, 243.8);
  --color-pink-5: rgb(255, 246.85, 249.4);
  --color-pink-3: rgb(255, 250.11, 251.64);
  --color-pink-1: rgb(255, 253.37, 253.88);
  --color-pink-dark: rgb(229.5, 82.8, 128.7);
  --color-pink-dark-80: rgb(204, 73.6, 114.4);
  --color-pink-dark-70: rgb(178.5, 64.4, 100.1);
  --color-pink-dark-60: rgb(153, 55.2, 85.8);
  --color-pink-dark-50: rgb(127.5, 46, 71.5);
  --color-salmon: rgb(255, 137, 137);
  --color-salmon-90: rgb(255, 148.8, 148.8);
  --color-salmon-80: rgb(255, 160.6, 160.6);
  --color-salmon-70: rgb(255, 172.4, 172.4);
  --color-salmon-60: rgb(255, 184.2, 184.2);
  --color-salmon-50: #ffc4c4;
  --color-salmon-40: rgb(255, 207.8, 207.8);
  --color-salmon-30: rgb(255, 219.6, 219.6);
  --color-salmon-20: rgb(255, 231.4, 231.4);
  --color-salmon-10: rgb(255, 243.2, 243.2);
  --color-salmon-5: rgb(255, 249.1, 249.1);
  --color-salmon-3: rgb(255, 251.46, 251.46);
  --color-salmon-1: rgb(255, 253.82, 253.82);
  --color-salmon-dark: rgb(229.5, 123.3, 123.3);
  --color-salmon-dark-80: rgb(204, 109.6, 109.6);
  --color-salmon-dark-70: rgb(178.5, 95.9, 95.9);
  --color-salmon-dark-60: rgb(153, 82.2, 82.2);
  --color-salmon-dark-50: rgb(127.5, 68.5, 68.5);
  --color-yellow: rgb(255, 196, 0);
  --color-yellow-90: rgb(255, 201.9, 25.5);
  --color-yellow-80: rgb(255, 207.8, 51);
  --color-yellow-70: rgb(255, 213.7, 76.5);
  --color-yellow-60: rgb(255, 219.6, 102);
  --color-yellow-50: rgb(255, 225.5, 127.5);
  --color-yellow-40: rgb(255, 231.4, 153);
  --color-yellow-30: rgb(255, 237.3, 178.5);
  --color-yellow-20: rgb(255, 243.2, 204);
  --color-yellow-10: rgb(255, 249.1, 229.5);
  --color-yellow-5: rgb(255, 252.05, 242.25);
  --color-yellow-3: rgb(255, 253.23, 247.35);
  --color-yellow-1: rgb(255, 254.41, 252.45);
  --color-yellow-dark: rgb(229.5, 176.4, 0);
  --color-yellow-dark-80: rgb(204, 156.8, 0);
  --color-yellow-dark-70: rgb(178.5, 137.2, 0);
  --color-yellow-dark-60: rgb(153, 117.6, 0);
  --color-yellow-dark-50: rgb(127.5, 98, 0);
  --color-green: rgb(0, 155, 72);
  --color-green-90: rgb(25.5, 165, 90.3);
  --color-green-80: rgb(51, 175, 108.6);
  --color-green-70: rgb(76.5, 185, 126.9);
  --color-green-60: rgb(102, 195, 145.2);
  --color-green-50: rgb(127.5, 205, 163.5);
  --color-green-40: rgb(153, 215, 181.8);
  --color-green-30: rgb(178.5, 225, 200.1);
  --color-green-20: rgb(204, 235, 218.4);
  --color-green-10: rgb(229.5, 245, 236.7);
  --color-green-5: rgb(242.25, 250, 245.85);
  --color-green-3: rgb(247.35, 252, 249.51);
  --color-green-1: rgb(252.45, 254, 253.17);
  --color-green-dark: rgb(0, 139.5, 64.8);
  --color-green-dark-80: rgb(0, 124, 57.6);
  --color-green-dark-70: rgb(0, 108.5, 50.4);
  --color-green-dark-60: rgb(0, 93, 43.2);
  --color-green-dark-50: rgb(0, 77.5, 36);
  --color-teal: rgb(10, 196, 172);
  --color-teal-90: rgb(34.5, 201.9, 180.3);
  --color-teal-80: rgb(59, 207.8, 188.6);
  --color-teal-70: rgb(83.5, 213.7, 196.9);
  --color-teal-60: rgb(108, 219.6, 205.2);
  --color-teal-50: rgb(132.5, 225.5, 213.5);
  --color-teal-40: rgb(157, 231.4, 221.8);
  --color-teal-30: rgb(181.5, 237.3, 230.1);
  --color-teal-20: rgb(206, 243.2, 238.4);
  --color-teal-10: rgb(230.5, 249.1, 246.7);
  --color-teal-5: rgb(242.75, 252.05, 250.85);
  --color-teal-3: rgb(247.65, 253.23, 252.51);
  --color-teal-1: rgb(252.55, 254.41, 254.17);
  --color-teal-dark: rgb(9, 176.4, 154.8);
  --color-teal-dark-80: rgb(8, 156.8, 137.6);
  --color-teal-dark-70: rgb(7, 137.2, 120.4);
  --color-teal-dark-60: rgb(6, 117.6, 103.2);
  --color-teal-dark-50: #056256;
  --color-blue: rgb(10, 74, 206);
  --color-blue-90: rgb(34.5, 92.1, 210.9);
  --color-blue-80: rgb(59, 110.2, 215.8);
  --color-blue-70: rgb(83.5, 128.3, 220.7);
  --color-blue-60: rgb(108, 146.4, 225.6);
  --color-blue-50: rgb(132.5, 164.5, 230.5);
  --color-blue-40: rgb(157, 182.6, 235.4);
  --color-blue-30: rgb(181.5, 200.7, 240.3);
  --color-blue-20: rgb(206, 218.8, 245.2);
  --color-blue-10: rgb(230.5, 236.9, 250.1);
  --color-blue-5: rgb(242.75, 245.95, 252.55);
  --color-blue-3: rgb(247.65, 249.57, 253.53);
  --color-blue-1: rgb(252.55, 253.19, 254.51);
  --color-blue-dark: rgb(9, 66.6, 185.4);
  --color-blue-dark-80: rgb(8, 59.2, 164.8);
  --color-blue-dark-70: rgb(7, 51.8, 144.2);
  --color-blue-dark-60: rgb(6, 44.4, 123.6);
  --color-blue-dark-50: #052567;
  --color-navy: rgb(0, 1, 101);
  --color-navy-90: rgb(25.5, 26.4, 116.4);
  --color-navy-80: rgb(51, 51.8, 131.8);
  --color-navy-70: rgb(76.5, 77.2, 147.2);
  --color-navy-60: rgb(102, 102.6, 162.6);
  --color-navy-50: rgb(127.5, 128, 178);
  --color-navy-40: rgb(153, 153.4, 193.4);
  --color-navy-30: rgb(178.5, 178.8, 208.8);
  --color-navy-20: rgb(204, 204.2, 224.2);
  --color-navy-10: rgb(229.5, 229.6, 239.6);
  --color-navy-5: rgb(242.25, 242.3, 247.3);
  --color-navy-3: rgb(247.35, 247.38, 250.38);
  --color-navy-1: rgb(252.45, 252.46, 253.46);
  --color-navy-dark: rgb(0, 0.9, 90.9);
  --color-navy-dark-80: rgb(0, 0.8, 80.8);
  --color-navy-dark-70: rgb(0, 0.7, 70.7);
  --color-navy-dark-60: rgb(0, 0.6, 60.6);
  --color-navy-dark-50: rgb(0, 0.5, 50.5);
  --color-purple: rgb(102, 45, 145);
  --color-purple-90: rgb(117.3, 66, 156);
  --color-purple-80: rgb(132.6, 87, 167);
  --color-purple-70: rgb(147.9, 108, 178);
  --color-purple-60: rgb(163.2, 129, 189);
  --color-purple-50: rgb(178.5, 150, 200);
  --color-purple-40: rgb(193.8, 171, 211);
  --color-purple-30: rgb(209.1, 192, 222);
  --color-purple-20: rgb(224.4, 213, 233);
  --color-purple-10: rgb(239.7, 234, 244);
  --color-purple-5: rgb(247.35, 244.5, 249.5);
  --color-purple-3: rgb(250.41, 248.7, 251.7);
  --color-purple-1: rgb(253.47, 252.9, 253.9);
  --color-purple-dark: rgb(91.8, 40.5, 130.5);
  --color-purple-dark-80: rgb(81.6, 36, 116);
  --color-purple-dark-70: rgb(71.4, 31.5, 101.5);
  --color-purple-dark-60: rgb(61.2, 27, 87);
  --color-purple-dark-50: rgb(51, 22.5, 72.5);
  --color-blue-05: var(--color-blue-5);
  --color-blue-03: var(--color-blue-3);
  --color-blue-01: var(--color-blue-1);
  --color-red-pill: --var(--color-pink);
  --color-white: #FFFFFF;
  --color-grey-dark-9: #09090B;
  --color-grey-dark-8: #18181B;
  --color-grey-dark-7: #27272A;
  --color-grey-dark-6: #3F3F46;
  --color-grey-dark-5: #52525B;
  --color-grey: #71717A;
  --color-grey-light-9: #A1A1AA;
  --color-grey-light-8: #D4D4D8;
  --color-grey-light-7: #E4E4E7;
  --color-grey-light-6: #F4F4F5;
  --color-grey-light-5: #FAFAFA;
  --color-blue-dark-9: #1D2758;
  --color-blue-dark-8: #2A3884;
  --color-blue-dark-7: #2E41A8;
  --color-blue-dark-6: #3850D2;
  --color-blue-dark-5: #3754EB;
  --color-blue: #4765FF;
  --color-blue-light-9: #7A8FFF;
  --color-blue-light-8: #A3B2FF;
  --color-blue-light-7: #BDC7FF;
  --color-blue-light-6: #E0E5FF;
  --color-blue-light-5: #F5F6FF;
  --color-red-dark-2: #991B1B;
  --color-red-dark-1: #B91C1C;
  --color-red: #DC2626;
  --color-red-light-1: #FECACA;
  --color-red-light-2: #F6EDED;
  --color-red-light-3: #FDE3ED;
  --color-green-dark-5: #15803D;
  --color-green-dark-2: #166534;
  --color-green-dark-1: #15803D;
  --color-green: #16A34A;
  --color-green-light-1: #C4EED3;
  --color-green-light-2: #ECF5EF;
  --color-green-light-3: #C4EED3;
  --color-green-light-4: #E8EFD7;
  --color-green-light-5: #E1F3EF;
  --color-yellow-dark-5: #775C08;
  --color-yellow-dark-2: #775C08;
  --color-yellow-dark-1: #C49608;
  --color-yellow: #F2C436;
  --color-yellow-light-1: #F4E1A4;
  --color-yellow-light-2: #FDF9ED;
  --color-purple-dark-5: #8A5D86;
  --color-purple-dark-2: #482562;
  --color-purple-dark-1: #662D91;
  --color-purple: #8A5DB6;
  --color-purple-light-1: #DFD6FF;
  --color-purple-light-2: #F4EFF8;
  --color-purple-light-3: #EDE7F6;
  --color-orange-light-1: #FAE8DB;
  --color-primary-text: var(--color-grey-dark-8);
  --color-primary-text-disabled: var(--color-grey-light-9);
  --color-standard-bar-blue: var(--color-blue-light-9);
  --color-blue-text: var(--color-blue);
  --color-blue-text-with-non-white-background: var(--color-blue-dark-5);
  --color-app-default-bg: var(--color-grey-light-5);
  --color-standard-bar-blue: #7A8FFF;
  --color-stacked-bar-seq-positive-5: #00494B;
  --color-stacked-bar-seq-positive-4: #076076;
  --color-stacked-bar-seq-positive-3: #076769;
  --color-stacked-bar-seq-positive-2: #3EA8A6;
  --color-stacked-bar-seq-positive-1: #BBE4D1;
  --color-stacked-bar-seq-neutral: #D4D4D8;
  --color-stacked-bar-seq-negative-1: #F0A882;
  --color-stacked-bar-seq-negative-2: #E47961;
  --color-stacked-bar-seq-negative-3: #C65154;
  --color-stacked-bar-seq-negative-4: #A52747;
  --color-stacked-bar-seq-negative-5: #81102D;
  --color-stacked-bar-cat-green: #2FB796;
  --color-stacked-bar-cat-blue: #516AEC;
  --color-stacked-bar-cat-yellow: #E7AD55;
  --color-stacked-bar-cat-purple: #8A5D86;
  --color-donut-green: #F3FCFA;
  --color-donut-yellow: #FDF8F2;
  --color-donut-purple: #F8F4FA;
  --color-donut-blue: #F5F6FF;
  --color-red-light-2: #F6EDED;
  --frnyc-blue-healthcare: #E2EDFD;
  --frnyc-orange-business-finance: #FAE8DB;
  --frnyc-green-education: #E1F3EF;
  --frnyc-red-human-social-services: #FDE3ED;
  --frnyc-yellow-green-hvac: #E8EFD7;
  --frnyc-purple-technology: #EDE7F6;
  --color-opacity-none: 0;
  --color-opacity-10: 0.1;
  --color-opacity-30: 0.3;
  --color-opacity-50: 0.5;
}
nv-icon-button,
:host {
  position: relative;
  display: inline-block;
  height: 32px;
  width: 32px;
}
nv-icon-button button.borderless-icon-button,
:host button.borderless-icon-button {
  position: relative;
  height: 100%;
  width: 100%;
  padding: 4px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  font-size: initial;
}
nv-icon-button button.borderless-icon-button::before,
:host button.borderless-icon-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  transition: background-color 0.2s ease-in-out;
}
nv-icon-button.red button::before,
:host.red button::before {
  background-color: transparent;
}
nv-icon-button.red button:focus-visible,
:host.red button:focus-visible {
  outline-color: var(--color-red);
}
nv-icon-button.red button:focus-visible::before,
:host.red button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-red-5);
}
nv-icon-button.red button:focus:not(:focus-visible),
:host.red button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.red button:hover,
  :host.red button:hover {
    outline-color: var(--color-red);
  }
  nv-icon-button.red button:hover:not(:focus-visible),
  :host.red button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.red button:hover::before,
  :host.red button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-red-5);
  }
}
nv-icon-button.red button:active,
:host.red button:active {
  outline: none;
}
nv-icon-button.red button:active::before,
:host.red button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-red-10);
}
nv-icon-button.red.is-inverted button:focus-visible::before,
:host.red.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(22, 3.8, 3.8);
}
@media (hover: hover) {
  nv-icon-button.red.is-inverted button:hover::before,
  :host.red.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: rgb(22, 3.8, 3.8);
  }
}
nv-icon-button.red.is-inverted button:active::before,
:host.red.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(22, 3.8, 3.8);
}
nv-icon-button.pink button::before,
:host.pink button::before {
  background-color: transparent;
}
nv-icon-button.pink button:focus-visible,
:host.pink button:focus-visible {
  outline-color: var(--color-pink);
}
nv-icon-button.pink button:focus-visible::before,
:host.pink button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-pink-5);
}
nv-icon-button.pink button:focus:not(:focus-visible),
:host.pink button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.pink button:hover,
  :host.pink button:hover {
    outline-color: var(--color-pink);
  }
  nv-icon-button.pink button:hover:not(:focus-visible),
  :host.pink button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.pink button:hover::before,
  :host.pink button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-pink-5);
  }
}
nv-icon-button.pink button:active,
:host.pink button:active {
  outline: none;
}
nv-icon-button.pink button:active::before,
:host.pink button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-pink-10);
}
nv-icon-button.pink.is-inverted button:focus-visible::before,
:host.pink.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(25.5, 9.2, 14.3);
}
@media (hover: hover) {
  nv-icon-button.pink.is-inverted button:hover::before,
  :host.pink.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: rgb(25.5, 9.2, 14.3);
  }
}
nv-icon-button.pink.is-inverted button:active::before,
:host.pink.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(25.5, 9.2, 14.3);
}
nv-icon-button.salmon button::before,
:host.salmon button::before {
  background-color: transparent;
}
nv-icon-button.salmon button:focus-visible,
:host.salmon button:focus-visible {
  outline-color: var(--color-salmon);
}
nv-icon-button.salmon button:focus-visible::before,
:host.salmon button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-salmon-5);
}
nv-icon-button.salmon button:focus:not(:focus-visible),
:host.salmon button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.salmon button:hover,
  :host.salmon button:hover {
    outline-color: var(--color-salmon);
  }
  nv-icon-button.salmon button:hover:not(:focus-visible),
  :host.salmon button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.salmon button:hover::before,
  :host.salmon button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-salmon-5);
  }
}
nv-icon-button.salmon button:active,
:host.salmon button:active {
  outline: none;
}
nv-icon-button.salmon button:active::before,
:host.salmon button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-salmon-10);
}
nv-icon-button.salmon.is-inverted button:focus-visible::before,
:host.salmon.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(25.5, 13.7, 13.7);
}
@media (hover: hover) {
  nv-icon-button.salmon.is-inverted button:hover::before,
  :host.salmon.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: rgb(25.5, 13.7, 13.7);
  }
}
nv-icon-button.salmon.is-inverted button:active::before,
:host.salmon.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(25.5, 13.7, 13.7);
}
nv-icon-button.yellow button::before,
:host.yellow button::before {
  background-color: transparent;
}
nv-icon-button.yellow button:focus-visible,
:host.yellow button:focus-visible {
  outline-color: var(--color-yellow);
}
nv-icon-button.yellow button:focus-visible::before,
:host.yellow button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-yellow-5);
}
nv-icon-button.yellow button:focus:not(:focus-visible),
:host.yellow button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.yellow button:hover,
  :host.yellow button:hover {
    outline-color: var(--color-yellow);
  }
  nv-icon-button.yellow button:hover:not(:focus-visible),
  :host.yellow button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.yellow button:hover::before,
  :host.yellow button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-yellow-5);
  }
}
nv-icon-button.yellow button:active,
:host.yellow button:active {
  outline: none;
}
nv-icon-button.yellow button:active::before,
:host.yellow button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-yellow-10);
}
nv-icon-button.yellow.is-inverted button:focus-visible::before,
:host.yellow.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(24.2, 19.6, 5.4);
}
@media (hover: hover) {
  nv-icon-button.yellow.is-inverted button:hover::before,
  :host.yellow.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: rgb(24.2, 19.6, 5.4);
  }
}
nv-icon-button.yellow.is-inverted button:active::before,
:host.yellow.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(24.2, 19.6, 5.4);
}
nv-icon-button.green button::before,
:host.green button::before {
  background-color: transparent;
}
nv-icon-button.green button:focus-visible,
:host.green button:focus-visible {
  outline-color: var(--color-green);
}
nv-icon-button.green button:focus-visible::before,
:host.green button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-green-5);
}
nv-icon-button.green button:focus:not(:focus-visible),
:host.green button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.green button:hover,
  :host.green button:hover {
    outline-color: var(--color-green);
  }
  nv-icon-button.green button:hover:not(:focus-visible),
  :host.green button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.green button:hover::before,
  :host.green button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-green-5);
  }
}
nv-icon-button.green button:active,
:host.green button:active {
  outline: none;
}
nv-icon-button.green button:active::before,
:host.green button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-green-10);
}
nv-icon-button.green.is-inverted button:focus-visible::before,
:host.green.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(2.2, 16.3, 7.4);
}
@media (hover: hover) {
  nv-icon-button.green.is-inverted button:hover::before,
  :host.green.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: rgb(2.2, 16.3, 7.4);
  }
}
nv-icon-button.green.is-inverted button:active::before,
:host.green.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(2.2, 16.3, 7.4);
}
nv-icon-button.teal button::before,
:host.teal button::before {
  background-color: transparent;
}
nv-icon-button.teal button:focus-visible,
:host.teal button:focus-visible {
  outline-color: var(--color-teal);
}
nv-icon-button.teal button:focus-visible::before,
:host.teal button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-teal-5);
}
nv-icon-button.teal button:focus:not(:focus-visible),
:host.teal button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.teal button:hover,
  :host.teal button:hover {
    outline-color: var(--color-teal);
  }
  nv-icon-button.teal button:hover:not(:focus-visible),
  :host.teal button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.teal button:hover::before,
  :host.teal button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-teal-5);
  }
}
nv-icon-button.teal button:active,
:host.teal button:active {
  outline: none;
}
nv-icon-button.teal button:active::before,
:host.teal button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-teal-10);
}
nv-icon-button.teal.is-inverted button:focus-visible::before,
:host.teal.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(1, 19.6, 17.2);
}
@media (hover: hover) {
  nv-icon-button.teal.is-inverted button:hover::before,
  :host.teal.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: rgb(1, 19.6, 17.2);
  }
}
nv-icon-button.teal.is-inverted button:active::before,
:host.teal.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(1, 19.6, 17.2);
}
nv-icon-button.blue button::before,
:host.blue button::before {
  background-color: transparent;
}
nv-icon-button.blue button:focus-visible,
:host.blue button:focus-visible {
  outline-color: var(--color-blue);
}
nv-icon-button.blue button:focus-visible::before,
:host.blue button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-blue-5);
}
nv-icon-button.blue button:focus:not(:focus-visible),
:host.blue button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.blue button:hover,
  :host.blue button:hover {
    outline-color: var(--color-blue);
  }
  nv-icon-button.blue button:hover:not(:focus-visible),
  :host.blue button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.blue button:hover::before,
  :host.blue button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-blue-5);
  }
}
nv-icon-button.blue button:active,
:host.blue button:active {
  outline: none;
}
nv-icon-button.blue button:active::before,
:host.blue button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-blue-10);
}
nv-icon-button.blue.is-inverted button:focus-visible::before,
:host.blue.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: #3850D2;
}
@media (hover: hover) {
  nv-icon-button.blue.is-inverted button:hover::before,
  :host.blue.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: #3850D2;
  }
}
nv-icon-button.blue.is-inverted button:active::before,
:host.blue.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: #2E41A8;
}
nv-icon-button.navy button::before,
:host.navy button::before {
  background-color: transparent;
}
nv-icon-button.navy button:focus-visible,
:host.navy button:focus-visible {
  outline-color: var(--color-navy);
}
nv-icon-button.navy button:focus-visible::before,
:host.navy button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-navy-5);
}
nv-icon-button.navy button:focus:not(:focus-visible),
:host.navy button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.navy button:hover,
  :host.navy button:hover {
    outline-color: var(--color-navy);
  }
  nv-icon-button.navy button:hover:not(:focus-visible),
  :host.navy button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.navy button:hover::before,
  :host.navy button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-navy-5);
  }
}
nv-icon-button.navy button:active,
:host.navy button:active {
  outline: none;
}
nv-icon-button.navy button:active::before,
:host.navy button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-navy-10);
}
nv-icon-button.navy.is-inverted button:focus-visible::before,
:host.navy.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(0, 0.1, 10.1);
}
@media (hover: hover) {
  nv-icon-button.navy.is-inverted button:hover::before,
  :host.navy.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: rgb(0, 0.1, 10.1);
  }
}
nv-icon-button.navy.is-inverted button:active::before,
:host.navy.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(0, 0.1, 10.1);
}
nv-icon-button.purple button::before,
:host.purple button::before {
  background-color: transparent;
}
nv-icon-button.purple button:focus-visible,
:host.purple button:focus-visible {
  outline-color: var(--color-purple);
}
nv-icon-button.purple button:focus-visible::before,
:host.purple button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-purple-5);
}
nv-icon-button.purple button:focus:not(:focus-visible),
:host.purple button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.purple button:hover,
  :host.purple button:hover {
    outline-color: var(--color-purple);
  }
  nv-icon-button.purple button:hover:not(:focus-visible),
  :host.purple button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.purple button:hover::before,
  :host.purple button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-purple-5);
  }
}
nv-icon-button.purple button:active,
:host.purple button:active {
  outline: none;
}
nv-icon-button.purple button:active::before,
:host.purple button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-purple-10);
}
nv-icon-button.purple.is-inverted button:focus-visible::before,
:host.purple.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(13.8, 9.3, 18.2);
}
@media (hover: hover) {
  nv-icon-button.purple.is-inverted button:hover::before,
  :host.purple.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: rgb(13.8, 9.3, 18.2);
  }
}
nv-icon-button.purple.is-inverted button:active::before,
:host.purple.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: rgb(13.8, 9.3, 18.2);
}
nv-icon-button.black button::before,
:host.black button::before {
  background-color: transparent;
}
nv-icon-button.black button:focus-visible,
:host.black button:focus-visible {
  outline-color: var(--color-black);
}
nv-icon-button.black button:focus-visible::before,
:host.black button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-black-5);
}
nv-icon-button.black button:focus:not(:focus-visible),
:host.black button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.black button:hover,
  :host.black button:hover {
    outline-color: var(--color-black);
  }
  nv-icon-button.black button:hover:not(:focus-visible),
  :host.black button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.black button:hover::before,
  :host.black button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-black-5);
  }
}
nv-icon-button.black button:active,
:host.black button:active {
  outline: none;
}
nv-icon-button.black button:active::before,
:host.black button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-black-10);
}
nv-icon-button.black.is-inverted button:focus-visible::before,
:host.black.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: black;
}
@media (hover: hover) {
  nv-icon-button.black.is-inverted button:hover::before,
  :host.black.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: black;
  }
}
nv-icon-button.black.is-inverted button:active::before,
:host.black.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: black;
}
nv-icon-button.grey button::before,
:host.grey button::before {
  background-color: transparent;
}
nv-icon-button.grey button:focus-visible,
:host.grey button:focus-visible {
  outline-color: var(--color-grey);
}
nv-icon-button.grey button:focus-visible::before,
:host.grey button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-grey-5);
}
nv-icon-button.grey button:focus:not(:focus-visible),
:host.grey button:focus:not(:focus-visible) {
  outline: none;
}
@media (hover: hover) {
  nv-icon-button.grey button:hover,
  :host.grey button:hover {
    outline-color: var(--color-grey);
  }
  nv-icon-button.grey button:hover:not(:focus-visible),
  :host.grey button:hover:not(:focus-visible) {
    outline: none;
  }
  nv-icon-button.grey button:hover::before,
  :host.grey button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: var(--color-grey-5);
  }
}
nv-icon-button.grey button:active,
:host.grey button:active {
  outline: none;
}
nv-icon-button.grey button:active::before,
:host.grey button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: var(--color-grey-10);
}
nv-icon-button.grey.is-inverted button:focus-visible::before,
:host.grey.is-inverted button:focus-visible::before {
  transition: background-color 0.2s ease-in-out;
  background-color: #3F3F46;
}
@media (hover: hover) {
  nv-icon-button.grey.is-inverted button:hover::before,
  :host.grey.is-inverted button:hover::before {
    transition: background-color 0.2s ease-in-out;
    background-color: #3F3F46;
  }
}
nv-icon-button.grey.is-inverted button:active::before,
:host.grey.is-inverted button:active::before {
  transition: background-color 0.2s ease-in-out;
  background-color: #27272A;
}
nv-icon-button.is-disabled,
:host.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
nv-icon-button.is-disabled button,
:host.is-disabled button {
  pointer-events: none;
}
nv-icon-button.is-disabled button:hover::before,
nv-icon-button.is-disabled button:focus::before,
nv-icon-button.is-disabled button:active::before,
:host.is-disabled button:hover::before,
:host.is-disabled button:focus::before,
:host.is-disabled button:active::before {
  transition: none;
  opacity: 0;
}
/*# sourceMappingURL=nv-icon-button-H2WXFDWL.css.map */
